module.exports = __webpack_public_path__ + "kyperson/pcweb/res/img/logo_name.2c8d9b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_name.png
// module id = vS6g
// module chunks = 101